import { render, staticRenderFns } from "./putLinkCd.vue?vue&type=template&id=6fb10904&scoped=true"
import script from "./putLinkCd.vue?vue&type=script&lang=js"
export * from "./putLinkCd.vue?vue&type=script&lang=js"
import style0 from "./putLinkCd.vue?vue&type=style&index=0&id=6fb10904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb10904",
  null
  
)

export default component.exports